export default [{
        path: '/warehouses',
        name: 'warehouses',
        component: () =>
            import ('@/views/modules/warehouses/warehouses-list/WarehousesList.vue'),
        meta: {
            resource: 'ACL',
            pageTitle: 'Almacenes',
            breadcrumb: [{
                text: 'Lista de almacenes',
                active: true
            }]
        }
    },
    {
        path: '/warehouse/create',
        name: 'warehouse-create',
        component: () =>
            import ('@/views/modules/warehouses/warehouses-store/WarehouseStore.vue'),
        meta: {
            pageTitle: 'Almacenes',
            breadcrumb: [{
                text: 'Lista de almacenes',
                to: { name: 'warehouses' }
            }, {
                text: 'Nuevo almacén',
                active: true
            }]
        }
    },
    {
        path: '/warehouse/:id/edit',
        name: 'warehouse-edit',
        component: () =>
            import ('@/views/modules/warehouses/warehouses-edit/WarehousesEdit.vue'),
        meta: {
            pageTitle: 'Almacenes',
            breadcrumb: [{
                text: 'Lista de almacenes',
                to: { name: 'warehouses' }
            }, {
                text: 'Editar almacén',
                active: true
            }]
        }
    }
]
